import { ref } from 'vue'
import axios from 'axios'

const cvEnabled = ref(null)

export function useCvFeature() {
  async function checkCvFeature() {
    if (cvEnabled.value !== null) return cvEnabled.value
    try {
      const res = await axios.get('/frontend/settings')
      cvEnabled.value = res.data?.cv_landing_enabled === 'true' || res.data?.cv_landing_enabled === true
    } catch {
      cvEnabled.value = false
    }
    return cvEnabled.value
  }

  function resetCvFeature() {
    cvEnabled.value = null
  }

  return { cvEnabled, checkCvFeature, resetCvFeature }
}
